import immerize from '../immerize'

const initalState = {
  status: '',
  error: null,

  marshals_online: 0,
  sessions: {},
}

function reducer(state = initalState, action) {
  let data
  switch (action.type) {
    case 'CLEAR_STORE':
      state = initalState
      break
    case 'SESSION_ONLINE_COUNT':
      data = action.payload.data
      state.error = null
      state.status = 'SESSION_ONLINE_COUNT'
      state.sessions = data.sessions
      state.marshals_online = data.marshalsOnline
      break
    case 'SESSION_STARTED':
      data = action.payload.data
      state.error = null
      state.status = 'SESSION_STARTED'
      state.sessions = { ...state.sessions, ...data }
      break
    case 'SESSION_DELETE':
      sessionDestroyByTrackerId(state, action.payload.data)
      break
    case 'SESSION_ONLINE_FULFILLED':
      data = action.payload.data
      state.error = null
      state.status = 'SESSION_ONLINE_FULFILLED'
      state.marshals_online = data.count
      break
    default:
      return state
  }
  return state
}

function sessionDestroyByTrackerId(state, trackerId) {
  const key = trackerId + ''

  if (state.sessions[key]) {
    delete state.sessions[key]
  }
}

export default immerize(reducer)
